import API_CLIENT from "../../utils/Api";

export async function GetOrders(page, filters = null) {
  if (filters) {
    return await API_CLIENT.get(`/orders?page=${page}&${filters}`);
  }
  return await API_CLIENT.get(`/orders?page=${page}`);
}

export async function GetOrderOverview() {
  return await API_CLIENT.get("/orders/overview");
}
export async function CancelOrder(id) {
  return await API_CLIENT.post(`/orders/cancel/${id}`);
}
